import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { initializeApp } from "firebase/app";
import { getDatabase, ref, get } from "firebase/database";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDZ0aV1WyiYEYY8OU7YlIAL6T1GxFgYLZg",
  authDomain: "courier-tracking-f48b1.firebaseapp.com",
  databaseURL: "https://courier-tracking-f48b1-default-rtdb.firebaseio.com",
  projectId: "courier-tracking-f48b1",
  storageBucket: "courier-tracking-f48b1.appspot.com",
  messagingSenderId: "525250641077",
  appId: "1:525250641077:web:39c04ae879a4a36cfd52fc",
  measurementId: "G-MS0GB18GQ9"
};

// Firebase init
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

const TrackingPage = () => {
  const [params] = useSearchParams();
  const trackingId = params.get("id");

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch data
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const snapshot = await get(ref(db, trackingId));
        if (snapshot.exists()) {
          setData(snapshot.val());
        } else {
          setData({ error: "Tracking ID not found." });
        }
      } catch (err) {
        setData({ error: "Failed to fetch data." });
      } finally {
        setLoading(false);
      }
    };

    if (trackingId) fetchData();
  }, [trackingId]);

  // Loading
  if (loading) {
    return (
      <div className="min-h-screen flex justify-center items-center bg-[#1e4ed8]">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-white"></div>
      </div>
    );
  }

  // Error
  if (!data || data.error) {
    return (
      <div className="min-h-screen flex justify-center items-center bg-[#1e4ed8]">
        <p className="text-white text-lg font-medium">
          {data?.error || "Something went wrong."}
        </p>
      </div>
    );
  }

  return (
    <main className="min-h-screen bg-[#1e4ed8] flex justify-center px-1 py-1">
      <div className="w-full max-w-[430px] bg-[#e9e9e9] rounded-[20px] p-5">

        {/* Title */}
        <h1 className="text-[28px] font-bold text-black mb-6">
          Tracking Details
        </h1>

        {/* Parcel Header */}
        <div className="flex items-center gap-4 mb-6">
          <div className="w-[70px] h-[70px] bg-[#0e2d5b] rounded-full flex items-center justify-center">
            <img src="/parcel.png" alt="parcel" className="w-10 h-10" />
          </div>

          <div>
            <h2 className="text-[22px] font-bold">PARCEL</h2>
            <p className="text-gray-500 text-sm">
              #Tracking ID: {trackingId}
            </p>
          </div>
        </div>

        {/* Info Card */}
        <div className="bg-[#efefef] rounded-[16px] p-5 mb-6 border border-gray-300">
          <div className="flex justify-between mb-3">
            <p>From: <b>{data.from}</b></p>
            <p>To: <b>{data.to}</b></p>
          </div>

          <p className="mb-2">
            Weight: <b>{data.weight}</b>
          </p>

          <p className="mb-2">
            Customer: <b>{data.customer}</b>
          </p>

          <p>
            Forwarding:: <b>{data.serviceTrackingId}</b>
          </p>
        </div>

        {/* Timeline */}
        <div className="bg-[#efefef] rounded-[16px] p-5 border border-gray-300 relative">
          {Array.isArray(data.steps) &&
            data.steps.map((step, index) => {
              const isActive = index <= data.currentStep;

              return (
                <div key={index} className="flex gap-4 relative pb-8">

                  {/* Line */}
                  {index !== data.steps.length - 1 && (
                    <div className="absolute left-[9px] top-5 w-[2px] h-full bg-blue-400"></div>
                  )}

                  {/* Dot */}
                  <div
                    className={`w-5 h-5 rounded-full mt-1 z-10 ${
                      isActive ? "bg-blue-900" : "bg-blue-300"
                    }`}
                  ></div>

                  {/* Text */}
                  <div>
                    <h3 className="text-[18px] font-bold text-black">
                      {step.label}
                    </h3>

                    {step.description && (
                      <p className="text-sm text-gray-500">
                        {step.description}
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </main>
  );
};

export default TrackingPage;